import { Components } from "@mui/material/styles";

export const MuiSwitch: Components['MuiSwitch'] = {
    styleOverrides: {
        root: {
            width: 28,
            height: 16,
            padding: 0,
            display: 'flex',
            marginLeft: 12,
            marginRight: 8,
            'cursor': 'pointer!important',
            '*': {
                'cursor': 'pointer!important'
            },
            '&:active': {
                '& .MuiSwitch-thumb': {
                    width: 15,
                },
                '& .MuiSwitch-switchBase.Mui-checked': {
                    transform: 'translateX(9px)',
                },
            },
            '& .MuiSwitch-switchBase': {
                padding: 2,
                '&.Mui-checked': {
                    transform: 'translateX(12px)',
                    color: '#fff',
                    '& + .MuiSwitch-track': {
                        opacity: 1,
                        background: 'linear-gradient(90deg, #00C3EA, #0090D1)'
                    },
                }
            },
            '& .MuiSwitch-thumb': {
                boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
                width: 12,
                height: 12,
                borderRadius: 6,
                transition: 'width 0.200s',
            },
            '& .Mui-disabled': {
                color: '#FFFFFF!important'
            },
            '& .MuiSwitch-track': {
                borderRadius: 8,
                opacity: 0.1,
                boxSizing: 'border-box',
            },
        }
    }
};
